<eds-accordion
  theme="white"
  [hasBorders]="true"
  padding="md"
  *ngIf="alerts.length > 0 && showFundAccordion"
>
  <eds-accordion-item
    *ngFor="let alert of alerts; let i = index"
    theme="compact"
    [isCompact]="true"
    [hideBorder]="true"
    [title]="alert.accordionTitle"
  >
    <p class="small" edsSpacing="xs" [innerHtml]="alert.accordionContent"></p>
  </eds-accordion-item>
</eds-accordion>

<!-- fund name,dropdown and downloadfactsheet  area -->
<ng-container *ngIf="showAlertPopup">
  <eds-simple-modal
    #modal
    [showModal]="showAlertPopup"
    [modalId]="alertConfig?.modalId"
    [config]="alertConfig"
    [closeAriaLabel]="alertWithPopup?.popupCloseLabel | translate"
    [modalAriaLabelledby]="alertWithPopup?.popupTitle | translate"
  >
    <div modal-body>
      <p [innerHtml]="alertWithPopup?.popupContent"></p>
    </div>

    <div modal-footer class="text-align-right">
      <button
        class="ft__btn"
        edsButton="secondary"
        size="normal"
        (click)="onClosePopUp()"
      >
        <span class="ft__btn__txt">{{ alertWithPopup?.popupCloseLabel }}</span>
      </button>

      <button
        class="ft__btn"
        edsButton="primary"
        size="normal"
        [noMargin]="true"
        (click)="onConfirmPopUp()"
      >
        <span class="ft__btn__txt">{{
          alertWithPopup?.popupConfirmLabel
        }}</span>
      </button>
    </div>
  </eds-simple-modal>
</ng-container>
